import type { ReactNode } from "react";

import { Logo } from "@gately/ui/logo";

/**
 * Centered, full-screen brand chrome for terminal states (error, 404). Kept
 * dependency-light — only Tailwind + Logo — so it renders even when the
 * failure is a top-level provider, and theme-aware via the dual Logo variant.
 */
export function StatusScreen({
  icon,
  title,
  description,
  actions,
}: {
  icon: ReactNode;
  title: string;
  description: string;
  actions: ReactNode;
}) {
  return (
    <main className="bg-background text-foreground flex min-h-screen flex-col items-center justify-center px-6 py-12">
      <div className="mb-10">
        <Logo variant="dark" withWordmark className="dark:hidden" />
        <Logo variant="light" withWordmark className="hidden dark:inline-flex" />
      </div>

      <div className="flex w-full max-w-md flex-col items-center text-center">
        <div className="bg-muted text-muted-foreground mb-6 flex size-14 items-center justify-center rounded-full">
          {icon}
        </div>
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        <p className="text-muted-foreground mt-3 text-base leading-relaxed">
          {description}
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {actions}
        </div>
      </div>
    </main>
  );
}
